import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center w-full h-full text-2xl font-bold text-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "disclaimer" }, [
  /*#__PURE__*/_createTextVNode(" Due to changes with Twitter's login service, we will be discontinuing its support. To continue playing uninterrupted, please attach an email address to your account. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" We will be disabling Login with Twitter on April 30th 2023. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Set email address")

import { set } from 'tiny-cookie';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Button from '@/components/UI/Button.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

onMounted(() => {
  set('twitter-warning', 'true');
});

function goToPreferences() {
  window.history.replaceState({}, document.title, window.location.pathname);
  router.push('/account?twitter_email=1');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Button, { onClick: goToPreferences }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ]))
}
}

})